var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDoc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 58 58",
    style: {
      enableBackground: "new 0 0 58 58"
    },
    xmlSpace: "preserve",
    width: "512px",
    height: "512px",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M50.95,12.187l-0.771-0.771L40.084,1.321L39.313,0.55C38.964,0.201,38.48,0,37.985,0H8.963C7.777,0,6.5,0.916,6.5,2.926V39   v16.537V56c0,0.837,0.842,1.653,1.838,1.91c0.05,0.013,0.098,0.032,0.15,0.042C8.644,57.983,8.803,58,8.963,58h40.074   c0.16,0,0.319-0.017,0.475-0.048c0.052-0.01,0.1-0.029,0.15-0.042C50.658,57.653,51.5,56.837,51.5,56v-0.463V39V13.978   C51.5,13.211,51.408,12.645,50.95,12.187z M47.935,12H39.5V3.565L47.935,12z M8.963,56c-0.071,0-0.135-0.026-0.198-0.049   C8.609,55.877,8.5,55.721,8.5,55.537V41h41v14.537c0,0.184-0.109,0.339-0.265,0.414C49.172,55.974,49.108,56,49.037,56H8.963z    M8.5,39V2.926C8.5,2.709,8.533,2,8.963,2h28.595C37.525,2.126,37.5,2.256,37.5,2.391V14h11.609c0.135,0,0.264-0.025,0.39-0.058   c0,0.015,0.001,0.021,0.001,0.036V39H8.5z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#6671CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.235,45.4c-0.424-0.446-0.957-0.805-1.6-1.073s-1.388-0.403-2.235-0.403h-3.035V54h3.814   c0.127,0,0.323-0.016,0.588-0.048c0.264-0.032,0.556-0.104,0.875-0.219c0.319-0.114,0.649-0.285,0.991-0.513   s0.649-0.54,0.923-0.937s0.499-0.889,0.677-1.477s0.267-1.297,0.267-2.126c0-0.602-0.105-1.188-0.314-1.757   C23.976,46.355,23.659,45.847,23.235,45.4z M22.039,51.73c-0.492,0.711-1.294,1.066-2.406,1.066h-1.627v-7.629h0.957   c0.784,0,1.422,0.103,1.914,0.308s0.882,0.474,1.169,0.807s0.48,0.704,0.581,1.114c0.1,0.41,0.15,0.825,0.15,1.244   C22.777,49.989,22.531,51.02,22.039,51.73z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#6671CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.265,45.072c-0.378-0.429-0.82-0.754-1.326-0.978s-1.06-0.335-1.661-0.335s-1.155,0.111-1.661,0.335   s-0.948,0.549-1.326,0.978c-0.378,0.429-0.675,0.964-0.889,1.606c-0.214,0.643-0.321,1.388-0.321,2.235s0.107,1.595,0.321,2.242   c0.214,0.647,0.51,1.185,0.889,1.613c0.378,0.429,0.82,0.752,1.326,0.971s1.06,0.328,1.661,0.328s1.155-0.109,1.661-0.328   s0.948-0.542,1.326-0.971c0.378-0.429,0.674-0.966,0.889-1.613c0.214-0.647,0.321-1.395,0.321-2.242s-0.107-1.593-0.321-2.235   C33.939,46.036,33.643,45.501,33.265,45.072z M32.588,50.698c-0.137,0.487-0.326,0.882-0.567,1.183   c-0.242,0.301-0.515,0.518-0.82,0.649c-0.306,0.132-0.627,0.198-0.964,0.198c-0.328,0-0.641-0.07-0.937-0.212   c-0.296-0.142-0.561-0.364-0.793-0.67s-0.415-0.699-0.547-1.183c-0.132-0.483-0.203-1.066-0.212-1.75   c0.009-0.702,0.082-1.294,0.219-1.777s0.326-0.877,0.567-1.183c0.241-0.306,0.515-0.521,0.82-0.649   c0.305-0.128,0.626-0.191,0.964-0.191c0.328,0,0.64,0.068,0.937,0.205c0.296,0.137,0.561,0.36,0.793,0.67s0.415,0.704,0.547,1.183   c0.132,0.479,0.203,1.06,0.212,1.743C32.797,49.616,32.725,50.211,32.588,50.698z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#6671CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.062,45.954c0.241-0.306,0.515-0.521,0.82-0.649c0.305-0.128,0.626-0.191,0.964-0.191c0.301,0,0.59,0.06,0.868,0.178   c0.278,0.118,0.531,0.31,0.759,0.574l1.135-1.012c-0.374-0.364-0.798-0.638-1.271-0.82c-0.474-0.183-0.984-0.273-1.531-0.273   c-0.593,0-1.144,0.111-1.654,0.335c-0.511,0.224-0.955,0.549-1.333,0.978c-0.378,0.429-0.675,0.964-0.889,1.606   c-0.214,0.643-0.321,1.388-0.321,2.235s0.107,1.595,0.321,2.242c0.214,0.647,0.51,1.185,0.889,1.613   c0.378,0.429,0.82,0.752,1.326,0.971s1.06,0.328,1.661,0.328c0.547,0,1.057-0.091,1.531-0.273c0.474-0.183,0.897-0.456,1.271-0.82   l-1.135-0.998c-0.237,0.265-0.499,0.456-0.786,0.574s-0.595,0.178-0.923,0.178s-0.641-0.07-0.937-0.212   c-0.296-0.142-0.561-0.364-0.793-0.67s-0.415-0.699-0.547-1.183c-0.132-0.483-0.203-1.066-0.212-1.75   c0.009-0.702,0.082-1.294,0.219-1.777S38.82,46.26,39.062,45.954z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#6671CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5,14h6c0.552,0,1-0.448,1-1s-0.448-1-1-1h-6c-0.552,0-1,0.448-1,1S12.948,14,13.5,14z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#6671CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5,19h9c0.552,0,1-0.448,1-1s-0.448-1-1-1h-9c-0.552,0-1,0.448-1,1S12.948,19,13.5,19z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#6671CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5,19c0.26,0,0.52-0.11,0.71-0.29c0.18-0.19,0.29-0.45,0.29-0.71c0-0.26-0.11-0.52-0.29-0.71   c-0.37-0.37-1.05-0.37-1.42,0c-0.18,0.19-0.29,0.45-0.29,0.71c0,0.26,0.11,0.52,0.29,0.71C25.98,18.89,26.24,19,26.5,19z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#6671CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5,19h8c0.552,0,1-0.448,1-1s-0.448-1-1-1h-8c-0.552,0-1,0.448-1,1S29.948,19,30.5,19z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#6671CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.79,32.29c-0.18,0.19-0.29,0.45-0.29,0.71c0,0.26,0.11,0.52,0.29,0.71C12.98,33.89,13.24,34,13.5,34   c0.26,0,0.52-0.11,0.71-0.29c0.18-0.19,0.29-0.45,0.29-0.71c0-0.27-0.11-0.52-0.29-0.71C13.84,31.92,13.16,31.92,12.79,32.29z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#6671CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5,32h-8c-0.552,0-1,0.448-1,1s0.448,1,1,1h8c0.552,0,1-0.448,1-1S26.052,32,25.5,32z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#6671CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5,17h-2c-0.552,0-1,0.448-1,1s0.448,1,1,1h2c0.552,0,1-0.448,1-1S45.052,17,44.5,17z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#6671CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5,24h22c0.552,0,1-0.448,1-1s-0.448-1-1-1h-22c-0.552,0-1,0.448-1,1S12.948,24,13.5,24z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#6671CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5,22h-6c-0.552,0-1,0.448-1,1s0.448,1,1,1h6c0.552,0,1-0.448,1-1S45.052,22,44.5,22z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#6671CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5,29h4c0.552,0,1-0.448,1-1s-0.448-1-1-1h-4c-0.552,0-1,0.448-1,1S12.948,29,13.5,29z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#6671CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5,27h-10c-0.552,0-1,0.448-1,1s0.448,1,1,1h10c0.552,0,1-0.448,1-1S32.052,27,31.5,27z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#6671CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5,27h-9c-0.552,0-1,0.448-1,1s0.448,1,1,1h9c0.552,0,1-0.448,1-1S45.052,27,44.5,27z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#6671CD"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoc);
export default __webpack_public_path__ + "static/media/doc.c617ab8e97c7d1e02e4f031335c6f014.svg";
export { ForwardRef as ReactComponent };